<div class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50" style="z-index: 1050;">
  <div class="bg-white rounded-3 p-4 w-100" style="max-width: 400px; text-align: center;">
    <h2 class="text-primary fw-semibold fs-6 mb-3">
      Nueva Versión
    </h2>
    <p class="text-secondary mb-4 small">
      Una nueva versión de la aplicación está disponible. Actualice la ventana de su navegador o haga clic en el botón Actualizar.
    </p>
    <div>
      <button class="btn btn-primary w-100" (click)="update.emit()">
        Actualizar
      </button>
    </div>
  </div>
</div>
